<template>
  <div class="profile-layout">

    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-header text">
                <slot name="header">
                  Додати Камеру
                </slot>
              </div>
              <div class="modal-body">
                <slot name="body">
                  <div class="text title-body">
                    ID кмери:
                  </div>
                  <div>
                    <input v-model="uuid" type="text" class="text uuid">
                  </div>
                </slot>
              </div>
              <div class="submits">
                <button class="cancel" @click="showModal = !showModal">Вiдмiнити</button>
                <button class="save" @click="save_uuid"> Зберегти</button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div class="title-profile-menu">
      <div class="text profile-title"> Профiль</div>
    </div>

    <div class="cameras-map">
      <div class="label">
        <label for="map" class="text">План камер: </label> 
      </div>
      <input @change="map_selected" type="file" class="" id="map" ref="fileupload">
      <button class="button download text" @click="download">Завантажити</button>
    </div>

    <div class="language">
      <div class="label">
        <label for="language-select" class="text">Мова користувача: </label> 
      </div>
      <select id="language-select" class="text">
          <option class="text" value="ukraine">Українська</option>
      </select>
    </div>
    <!-- <div class="passwords">
      <div class="label" >
        <label for="password" class="text">Змiна пароля: </label> 
      </div>
      <input v-model="old_pass" type="password" class="text" id="password">
      <input v-model="new_pass_1" type="password" class="text" id="password">
      <input v-model="new_pass_2" type="password" class="text" id="password">
    </div> -->
    <div class="submits"> 
      <button  class="button save text" @click="submit">Зберегти</button>
    </div>
    <div class="add-camera-uid">
      <button class="button add-camera text" @click="showModal = !showModal">Додати Камеру</button>
    </div>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
      
    name: "ProfileMenuComponent",

    props: ['camera_added'],

    data() {
      return {
        ge_sid: sessionStorage.getItem('ge_sid'),
        headers: {'Content-Type':'application/json', 'Authorization':'Token ' + sessionStorage.getItem('auth_token')},
        // url: 'http://127.0.0.1:8000/',
        url: '/api/',
        file_selected: null,
        showModal: false,
        uuid: '',
      }
    },

    watch: {
      camera_added() {
        if(this.camera_added) {
          this.showModal = false
          this.file_selected = null
        }
      }
    },

    methods: {
      
      map_selected(event) {
        this.file_selected = event.target.files[0]
      },

      download() {
        let body = new FormData()
        body.append('upload_file', this.file_selected, this.file_selected.name)
        axios({
          method: "post",
          url: this.url + "upload-map",
          data: body,
          headers: this.headers,
        })
        .then((response) => {
          this.$refs.fileupload.value=null
          this.modal('200', 'Успiх', 'Карта завантажена')
          this.upadte_map()
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.modal(error.response.status, 'Помилка', 'Невiрний формат файлу. Файл повинен бути в форматi: jpg, jpeg, png.')
          }
          if (error.response.status === 413) {
            this.modal(error.response.status, 'Помилка', 'Завеликий розмiр файлу. Максимальний розмiр має бути 3MB. ')
          }

        })
        
      },

      save_uuid() {
        this.$emit('add_camera', {
          uuid: this.uuid
        })
      },
      
      modal (status, title_modal, text_modal) {
        this.$emit('modal_message', {
          status: status,
          title_modal:title_modal,
          text_modal:text_modal
        })
      },

      upadte_map() {
        this.$emit( 'map_updated', {
          'status':'updated'
        })
      }


    },

  }
</script>

<style scoped>

  .title-profile-menu {
    width: 265px;
    height: 30px;
    margin-bottom: 17px;
    background: #383838;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
  }

  .profile-title {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
  }

  .label {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .cameras-map {
    margin-bottom: 5px;
  }

  #map {
    margin-bottom: 2px;
    width: 265px;
  }

  #password, #language-select, #name {
    border: none;
    min-width: 260px;
    height: 25px;
    background: #848484;
    border-radius: 5px;
    font-style: normal;
    font-size: 14px;
    margin-bottom: 5px;
  }

  .button {
    margin-left: 140px;
    width: 122px;
    height: 31px;
    background: #83931B;
    border-radius: 10px;
    display: inline-block;
    border: none;
    cursor: pointer;
    transition-duration: 0.4s;
    text-align: center;
    font-size: 14px;
    line-height: 16px;
    font-weight: bold;
  }

  .add-camera {
    margin-top: 10px;
    margin-bottom: 5px;
    margin-left: 0px;
    width: 265px;

  }

  .uuid {
    border: none;
    min-width: 310px;
    height: 28px;
    background: #848484;
    border-radius: 5px;
    font-style: normal;
    font-size: 16px;
  }

  .button:hover {
    background-color: #647014;
  }


 .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background-color: rgba(0, 0, 0, .6); */
    display: table;
    transition: opacity 0.3s ease;
  }
  
  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
  
  .modal-container {
    width: 310px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }
  
  .modal-header{
    margin-top: 0;
    color: black;
    text-align: center;
    font-size: 18px;
    padding-bottom: 10px;
  }
  
  .modal-body {
    margin: 20px 0;
    line-height: 1.5;
  }

  .title-body {
    color: black;
  }
  
  .submits {
    text-align: right;
  }
  
  .cancel {
    width: 122px;
    height: 31px;
    background: #848484;
    border-radius: 10px;
    display: inline-block;
    border: none;
    cursor: pointer;
    transition-duration: 0.4s;
    text-align: center;
    font-size: 14px;
    line-height: 16px;
    font-weight: bold;
    margin-right: 5px;
  }

  .cancel:hover {
    background-color: #5e5e5e;
  }

  .save {
    width: 122px;
    height: 31px;
    background: #83931B;
    border-radius: 10px;
    display: inline-block;
    border: none;
    cursor: pointer;
    transition-duration: 0.4s;
    text-align: center;
    font-size: 14px;
    line-height: 16px;
    font-weight: bold;
  }

  .save:hover {
    background-color: #647014;
  }
 
  .modal-enter {
    opacity: 0;
  }
  
  .modal-leave-active {
    opacity: 0;
  }
  
  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  


</style>